import PropTypes from 'prop-types';

import {
  isNodeEmpty,
  PARAGRAPH_DEFINITIONS,
  Placeholder,
} from '@xing-com/content-editor-plugin-helpers';

import { PARAGRAPH_TAG_NAME } from './constants';

const Paragraph = ({
  className,
  PARAGRAPH_TAG = PARAGRAPH_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === PARAGRAPH_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;

      if (placeholder && isNodeEmpty(element)) {
        return (
          <PARAGRAPH_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={PARAGRAPH_DEFINITIONS.type}
            className={className}
          >
            {Placeholder(children, className, placeholder)}
          </PARAGRAPH_TAG>
        );
      } else {
        return (
          <PARAGRAPH_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={PARAGRAPH_DEFINITIONS.type}
            className={className}
          >
            {children}
          </PARAGRAPH_TAG>
        );
      }
    }
  };
  return RenderLeaf;
};

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  PARAGRAPH_TAG: PropTypes.node,
};

export { Paragraph };
